






































import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator';

/**
 * Components
 */
import FileInput from '@/components/_global/FileInput.vue';

/**
 * Composant adaptatif d'édition de champ.
 */
@Component({ components: { FileInput } })
export default class GenericEditorComponent extends Vue {
	/** Injections */
	fileType = File;

	/** Propriétés */
	@Prop()
	label!: string;
	@Prop()
	meta!: any;

	/** v-model */
	@Model('value-changed')
	value: any;
	valueModel: any = this.value;
	valueChanged(d: any) {
		this.$emit('value-changed', d);
	}
	@Watch('valueModel')
	valueModelWatcher(val: any) {
		this.valueChanged(val);
	}

	@Watch('value')
	valueWatcher(val: any) {
		this.valueModel = val;
	}
}
